import {createFeatureSelector, createSelector} from '@ngrx/store';
import { TaskFormState } from './reducer/task-form.reducer';
import { StoreKeys } from '../../models/store-keys';

export const selectTaskFormFeature = createFeatureSelector<TaskFormState>(StoreKeys.TASK_FORM);

export const selectTaskFormDatas = createSelector(selectTaskFormFeature, state => state.datas);
